import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card'
import { ActivatedRoute, Router } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { Dictionary, PlayService } from '../../../service/play/play.service'
import { DdcLoadingSkeletonComponent } from '../ddc-loading-skeleton/ddc-loading-skeleton.component'

@Component({
  selector: 'ddc-flashcard-mode',
  templateUrl: './ddc-flashcard-mode.component.html',
  styleUrls: ['./ddc-flashcard-mode.component.scss'],
  imports: [
    MatCard,
    MatCardTitle,
    MatCardContent,
    AngularMaterialsModules,
    CommonModule,
    DdcLoadingSkeletonComponent,
  ],
})
export class DdcFlashcardModeComponent implements OnInit {
  dictionaryId!: number
  dictionary: Dictionary | null = null
  loading = true
  error: string | null = null

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private playService: PlayService,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('dictionaryId')
      if (id) {
        this.dictionaryId = +id
        this.fetchDictionary()
      } else {
        this.error = 'No dictionary selected.'
        this.loading = false
      }
    })
  }

  fetchDictionary(): void {
    this.loading = true
    this.playService.getDictionary(this.dictionaryId).subscribe({
      next: data => {
        this.dictionary = data
        this.loading = false
      },
      error: err => {
        this.error = 'Failed to load dictionary.'
        this.loading = false
      },
    })
  }

  goToFlashcards(type: 'words' | 'pairs'): void {
    this.router.navigate(['/flashcards', this.dictionaryId, type])
  }
}
